import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getSeoLinksBlockData } from "../../../redux/pages_Reducer";
import { StateType } from "../../../redux/redux-store";
import Constants from "../../../constants";
import AccordionElement from "./AccordionElement";

import { oneSeoLinkBlockData } from "../../../types/pagesTypes";

type Props = {
	pageName:
		| "home"
		| "mainCategory"
		| "categoryLastLevel"
		| "outputBordAD"
		| "workCategoryLastLevel"
		| "workMainCategory"
		| "workOutputBordAD";
	categoryName?: string;
};

const SeoLinksBlock: React.FC<Props> = ({ pageName, categoryName }) => {
	const dispatch: any = useDispatch();
	const { i18n, t } = useTranslation();
	const getLinksHtmlBlock = useSelector(() => getSeoLinksBlockData);
	const [currentData, setCurrentData] = useState<oneSeoLinkBlockData | null>(
		null
	);
	const [title, setTitle] = useState("");

	const seoLinksBlockData = useSelector(
		(state: StateType) => state.pagesData.seoLinksBlockData
	);
	const currentCategory = useSelector(
		(state: StateType) => state.categoryData.view
	);
	const noticeView = useSelector(
		(state: StateType) => state.publicNotice.noticeView
	);
	const pageTitle: Record<Props["pageName"], string> = {
		home: t("Як розмістити оголошення безкоштовно"),
		mainCategory: `${t("Як розмістити оголошення безкоштовно в рубрику")} ${currentCategory?.name}`,
		categoryLastLevel: `${t("Як розмістити оголошення безкоштовно в рубрику")} ${categoryName || ""}`,
		outputBordAD: `${t("Як розмістити оголошення безкоштовно в рубрику")} ${noticeView.category_name}`,
		workCategoryLastLevel: `${t("Як розмістити оголошення безкоштовно в рубрику")} ${categoryName || ""}`,
		workMainCategory: `${t("Як розмістити оголошення безкоштовно в рубрику")} ${currentCategory?.name}`,
		workOutputBordAD: `${t("Як розмістити оголошення безкоштовно в рубрику")} ${noticeView.category_name}`,
	};

	useEffect(() => {
		dispatch(getLinksHtmlBlock());
	}, [i18n.language]);

	useEffect(() => {
		const currentPageData: oneSeoLinkBlockData | undefined =
			seoLinksBlockData.find(
				(item: oneSeoLinkBlockData) =>
					item.pageId === Constants.pageIdForSeoLinksBlock[pageName]
			);
		if (currentPageData) {
			setCurrentData(currentPageData);
		}
	}, [seoLinksBlockData, pageName]);

	useEffect(() => {
		setTitle(pageTitle[pageName]);
	}, [
		pageName,
		currentCategory?.name,
		noticeView.category_name,
		categoryName,
		i18n.language,
	]);

	return (
		<AccordionElement title={title}>
			<div dangerouslySetInnerHTML={{ __html: currentData?.htmlBlock || "" }} />
		</AccordionElement>
	);
};

export default SeoLinksBlock;
